import PageTitle from "../components/PageTitle";
import { useState, useEffect } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
import ApiCall from "../common/ApiCall";
import Index from "../view/BlogCat/Index";
import HomeIcon from "../components/Iocns/HomeIcon";
import { useSelector } from "react-redux";
import { getSlugByLang } from "../common/Helper";
import { useNavigate } from "react-router-dom";

export default function BlogCategoryController() {
    const [blogCatList, setCatBlogList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [breadcrumbList, setBreadcrumbList] = useState([])
    const user = useSelector((state) => state.user);
    const slugLang = getSlugByLang(user?.language)
    const navigate = useNavigate()

    const getBlogCatPageList = async () => {
        setIsLoading(true)
        const getList = await ApiCall('get', 'blog-category-list')
        setIsLoading(false)
        if (getList) {

            if (getList?.data?.success) {
                setCatBlogList(getList.data.list)

                setBreadcrumbList([
                    {
                        name: <HomeIcon />,
                        url: "/" + slugLang
                    },
                    {
                        name: "Blog",
                        url: ('/' + slugLang) + '/blog'
                    },
                    {
                        name: "Category",
                    },

                ])


            } else {
                navigate(-1)
            }
        } else {
            navigate(-1)
        }
    }


    useEffect(() => {
        let sl = getSlugByLang(user?.language)
        setBreadcrumbList([
            {
                name: <HomeIcon />,
                url: "/" + sl
            },
            {
                name: "Blog",
                url: ('/' + sl) + '/blog'
            },
            {
                name: "Category",
            },
        ])
    }, [user?.language]);
    

    useEffect(() => {
        (async () => {
            await getBlogCatPageList()
        })();
    }, []);

    return (
        <>
            <PageTitle title={'Blog Categories'} />
            <Index
                blogCatList={blogCatList}
                isLoading={isLoading}
                breadcrumbList={breadcrumbList}
            />
        </>
    )

}